module.exports = __webpack_public_path__ + "img/cover.8483857b.png";